import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Card, Tabs, Badge, Modal, Icon } from 'antd';
import Urls from 'kts-platform-frame/entry/constant/Urls';
import MyStore from 'kts-platform-frame/redux/MyStore';
import AuthConfirm from './UI.AuthConfirm';
import AuthSelect from './UI.AuthSelect';
import AuthRecord from './UI.AuthRecord';
import AuthLogging from './UI.AuthLogging.List';
import { InvoiceImport } from 'kts-platform-frame/display/part';
import AuthStatics from './AuthStatics';
const css = require('./index.scss');
const TabPane = Tabs.TabPane;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}


/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    // public state: ModulesState = new ModulesState(); 
    // state = {
    //     currentTab: '2',
    //     confirmRandom: 0,
    //     selectRandom: 1,
    //     recordRandom: 2,
    // };
    constructor(props: any) {
        super(props, ModulesAction);
        let tab;
        if (this.getModuleName(location.pathname) === 'authSelect') {
            tab = '1';
        } else if (this.getModuleName(location.pathname) === 'authRecord') {
            tab = '3';
        } else if (this.getModuleName(location.pathname) === 'authConfirm') {
            tab = '2';
        } else if (this.getModuleName(location.pathname) === 'authlogging') {
            tab = '5';
        }
        else {
            tab = '4';
        }
        this.modulesState.currentTab = tab;
    }

    handleRefresh = () => {
        if (this.modulesState.currentTab === '1') {
            ModulesAction.refresh(1);
        } else if (this.modulesState.currentTab === '2') {
            ModulesAction.refresh(2);
        } else if (this.modulesState.currentTab === '3') {
            ModulesAction.refresh(3);
        } else {
            console.error('currentTab参数错误', this.modulesState.currentTab);
        }
    }
    componentDidMount() {

    }
    componentWillUnmount() {
        MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
    }

    // showModal = () => {
    //     Action.showModal();
    // }

    render() {
        return (
            <Card style={{ height: '100vh' }} className={css['invoiceGroup']} bordered={false}>
                <div style={{ height: '100%' }} className={css['modules']}>
                    <Tabs
                        onChange={ModulesAction.changeTab}
                        defaultActiveKey={this.modulesState.currentTab}
                        type="card"
                    >
                        <TabPane tab={<div ><Icon type="safety" /><span className="bold_number">进项认证</span></div>} key={'1'}>
                            <AuthSelect random={this.modulesState.selectRandom} />
                        </TabPane>
                        <TabPane
                            tab={
                                <Badge
                                    count={this.modulesState.confirmTotal}
                                    style={{ backgroundColor: '#87d068', }}
                                    overflowCount={999}
                                    offset={[1, 5]}
                                ><Icon type="bars" /><span className="bold_number">确认列表</span>
                                </Badge>
                            }
                            key={'2'}
                        >
                            <AuthConfirm random={this.modulesState.confirmRandom} />
                        </TabPane>
                        <TabPane tab={<div><Icon type="lurujilu" /><span className="bold_number">认证记录</span></div>} key={'3'}>
                            <AuthRecord random={this.modulesState.recordRandom} />
                        </TabPane>
                        <TabPane tab={<div><Icon type="baobiao" /><span className="bold_number">进项报表</span></div>} key={'4'}>
                            <AuthStatics />
                        </TabPane>
                        <TabPane tab={<div><Icon type="bars" /><span className="bold_number">录入记录</span></div>} key={'5'}>
                            <AuthLogging />
                        </TabPane>
                    </Tabs>
                </div>

            </Card >
        );
    }
    private getModuleName(str: string): string {
        const arr = str.split('/');
        return arr[3];
    }

    private showInvoiceInPanel = () => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const downloadUrl = `${Urls.INVOICE_AUTH_DOWNLOAD_FILE}?companyId=${companyId}`;
        const urlData = {
            // key4: Urls.logInvoiceMANUAL,
            scankey4: Urls.INVOICE_AUTH_QRCODE,
            downloadurl: downloadUrl,
            url: Urls.INVOICE_AUTH_DRAFT_BY_FILE,
            scankey4type: 'get',
        };
        MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
            Components: <InvoiceImport urlData={urlData} refreshInvoice={() => { this.handleRefresh(); }} />,
            title: '发票勾选'
        });
    }
    private handleCommit = () => {
        if (this.modulesState.draftedLength > 0) {
            this.modulesState.authNoteDisplay = true;
            this.setModulesState();
        } else {
            Modal.info({
                title: '提示',
                content: '未勾选数据，请检查！'
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.Components.tsx